<template>
    <v-form ref="etapeInfoSpplementaires" id="etapeInfoSpplementaires" v-model="$storeCandidature.etapeInfoSpplementairesValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <div id="terminale">
                <v-layout row wrap>
                    <h3>{{$storeCandidature.langueFormulaire == 'en' ? '' : 'Parcours :'}}</h3>
                    <hr size="5" width="100%" color="secondary" class='mb-2'>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SituationActuelleList"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Situation Actuelle'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout row wrap xs12>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeScolaireList"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.AnneeScolaire"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Année Scolaire'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.Diplome"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Diplôme'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle && $storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle.Id == fileIdSalarie" row wrap xs12>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.Entreprise"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Entreprise'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.Profession"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Profession'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4 text-xs-left>
                        <v-flex v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.Profession">
                            <v-card elevation="1">
                                <span v-if="$storeCandidature.langueFormulaire == 'en'"></span>
                                <span v-if="$storeCandidature.langueFormulaire != 'en'">Profession depuis</span>
                                <v-layout xs6>
                                    <v-flex xs2>
                                        <v-icon>calendar_today</v-icon>
                                    </v-flex>
                                    <v-flex xs4 class="ml-3">
                                        <vc-date-picker v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.ProfessionDepuis" 
                                                        update-on-input @input="$storeCandidature.candidatureChanged = true"></vc-date-picker>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field type="number"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.NbrDAnneeDExperienceDansLeDomaineViseSalarie"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Nbr d\'année Expérience dans le domaine visé'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.AdresseEntreprise"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Adresse entreprise'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.CPEntreprise"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'CP entreprise'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :counter="30"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.VilleEntreprise"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Ville entreprise'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>                        
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.PaysList"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.PaysEntreprise"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Pays entreprise'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
                <v-layout v-if="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle && $storeCandidature.sasCandidature.VAECoursDuSoir.SituationActuelle.Id == fileIdDemandeurEmplois" row wrap xs12>
                    <v-flex xs4 text-xs-left>
                        <v-card elevation="1">
                            <span v-if="$storeCandidature.langueFormulaire == 'en'"></span>
                            <span v-if="$storeCandidature.langueFormulaire != 'en'">Chômeur depuis</span>
                            <v-layout xs6>
                                <v-flex xs2>
                                    <v-icon>calendar_today</v-icon>
                                </v-flex>
                                <v-flex xs4 class="ml-3">
                                    <vc-date-picker v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.ChomeurDepuis"
                                                    update-on-input @input="$storeCandidature.candidatureChanged = true"></vc-date-picker>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                    <v-flex xs4>
                        <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.SituationFinanciereList"
                                        v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.SituationFinanciere"
                                        :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Situation Financiere'"
                                        :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                        item-value="Id"
                                        return-object
                                        chips
                                        deletable-chips
                                        @change="$storeCandidature.candidatureChanged = true">
                        </v-autocomplete>
                    </v-flex><v-flex xs4></v-flex>
                    <v-flex xs4>
                        <v-text-field type="number"
                                      v-model="$storeCandidature.sasCandidature.VAECoursDuSoir.NbrDAnneeDExperienceDansLeDomaineViseSalarie"
                                      :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Nbr d\'année Expérience dans le domaine visé'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs4>
                        <v-text-field :label="$storeCandidature.langueFormulaire == 'en' ? '' : 'Dernier emplois'"
                                      @change="$storeCandidature.candidatureChanged = true">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </div>
            <ComponentListParcoursScolaire class="mt-3" />
        </v-container>
    </v-form>
</template>
<script>
    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                //fileId de la valeur catalogue Situation actuelle = Salarié
                fileIdSalarie: 3935,
                //fileId de la valeur catalogue Situation actuelle = Demandeur d'emplois
                fileIdDemandeurEmplois: 3938,

            }
        },

        methods: {
        },

        mounted() {
            if (this.$refs.etapeInfoSpplementaires) {
                this.$refs.etapeInfoSpplementaires.validate()
            }
        },
    }
</script>

